// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__24CwN","footer":"ModalUpdate_footer__1CnaC"};